'use strict';

const ROLE_NAMES = Object.freeze({
  ADMIN: 'admin',
  CHEF: 'chef',
  SALES: 'sälj',
  BOARD: 'styrelse',
  EMPLOYEE: 'anställd',
  CONTRACTOR: 'underkonsult',
});

const ROLE_ALIASES = Object.freeze({
  a: ROLE_NAMES.ADMIN,
  admin: ROLE_NAMES.ADMIN,
  k: ROLE_NAMES.CHEF,
  chef: ROLE_NAMES.CHEF,
  kc: ROLE_NAMES.CHEF,
  s: ROLE_NAMES.SALES,
  sales: ROLE_NAMES.SALES,
  sälj: ROLE_NAMES.SALES,
  b: ROLE_NAMES.BOARD,
  board: ROLE_NAMES.BOARD,
  styrelse: ROLE_NAMES.BOARD,
  n: '',
  employee: '',
  anställd: '',
  contractor: '',
  underkonsult: '',
  '': '',
});

const ROLE_OPTIONS = Object.freeze([
  { value: 'n', label: 'Anställd' },
  { value: 'a', label: 'Admin' },
  { value: 's', label: 'Sälj' },
  { value: 'b', label: 'Styrelse' },
  { value: 'k', label: 'Chef' },
]);

function normalizeRole(role) {
  if (role === null || role === undefined) {
    return '';
  }

  return String(role).trim().toLowerCase();
}

function parseRoles(value) {
  if (!value) {
    return [];
  }

  const normalizedRoles = String(value)
    .split(',')
    .map(normalizeRole)
    .map((role) => ROLE_ALIASES.hasOwnProperty(role) ? ROLE_ALIASES[role] : role)
    .filter(Boolean);

  return [...new Set(normalizedRoles)];
}

function getRoleValue(user) {
  if (!user) {
    return '';
  }

  return user.role;
}

function hasRole(user, role) {
  const normalizedRole = ROLE_ALIASES[normalizeRole(role)] || normalizeRole(role);
  return parseRoles(getRoleValue(user)).includes(normalizedRole);
}

function hasAnyRole(user, roles) {
  return roles.some((role) => hasRole(user, role));
}

const arAdmin = (user) => hasRole(user, ROLE_NAMES.ADMIN);
const arChef = (user) => hasRole(user, ROLE_NAMES.CHEF);
const arSalj = (user) => hasRole(user, ROLE_NAMES.SALES);
const arStyrelse = (user) => hasRole(user, ROLE_NAMES.BOARD);

module.exports = {
  ROLE_NAMES,
  ROLE_ALIASES,
  ROLE_OPTIONS,
  normalizeRole,
  parseRoles,
  getRoleValue,
  hasRole,
  hasAnyRole,
  arAdmin,
  arChef,
  arSalj,
  arStyrelse,
};
